// AI 助手 mobile 全屏抽屉 (≤767px 触发，桌面端不渲染)
import React, { useEffect, useRef } from 'react';
import { useI18n } from '../lib/i18n';

const QUICK_QUESTIONS_ZH = [
  '给我一个例子',
  '用什么方法能入门?',
  '我需要哪些数学基础?',
  '最近有什么新进展?'
];
const QUICK_QUESTIONS_EN = [
  'Give me an example',
  'How do I get started?',
  'What math do I need?',
  'Any recent breakthroughs?'
];

export function AIFabTrigger({ onClick, hasUnread, label }) {
  return (
    <button
      type="button"
      className={'ai-fab-trigger' + (hasUnread ? ' has-unread' : '')}
      onClick={onClick}
      aria-label={label || t('problem.openChat') || '打开 AI 助手'}
    >
      💬
    </button>
  );
}

export default function AIDrawerMobile({ open, onClose, problem, messages, onSend, onReset, sending, input, setInput }) {
  const { lang, t } = useI18n();
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current && open) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, open]);

  if (!open) return null;

  const quick = lang === 'zh-CN' ? QUICK_QUESTIONS_ZH : QUICK_QUESTIONS_EN;

  const handleSend = (text) => {
    const v = (text ?? input).trim();
    if (!v || sending) return;
    onSend(v);
    setInput('');
  };

  return (
    <div className="ai-mobile-drawer" role="dialog" aria-modal="true" aria-label="AI 助手">
      <div className="ai-mobile-header">
        <div>
          <div className="text-base font-bold text-violet-200">{t('hc_99426362')}</div>
          <div className="text-xs text-slate-500 truncate max-w-[60vw]">{problem?.title || problem?.titleEn}</div>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="text-slate-400 hover:text-slate-200 text-2xl min-w-[44px] min-h-[44px] flex items-center justify-center"
          aria-label="关闭"
        >×</button>
      </div>

      <div ref={scrollRef} className="ai-mobile-body space-y-3">
        {messages.length === 0 ? (
          <div className="text-center text-slate-500 py-8">
            <div className="text-3xl mb-2">🤖</div>
            <p className="text-sm">{t('hc_40752456')}</p>
            <div className="mt-4 flex flex-wrap gap-2 justify-center">
              {quick.map((q, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => handleSend(q)}
                  className="text-xs px-3 py-2 rounded-full bg-violet-500/15 text-violet-200 border border-violet-500/30 min-h-[44px]"
                >
                  {q}
                </button>
              ))}
            </div>
          </div>
        ) : (
          messages.map((m, i) => (
            <div key={i} className={`flex gap-2 ${m.role === 'user' ? 'justify-end' : 'justify-start'}`}>
              {m.role === 'assistant' && (
                <div className="w-7 h-7 rounded-full bg-gradient-to-br from-violet-500 to-fuchsia-500 flex items-center justify-center text-xs flex-shrink-0">🤖</div>
              )}
              <div className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm leading-relaxed ${
                m.role === 'user'
                  ? 'bg-violet-500/20 border border-violet-500/30 text-slate-100'
                  : 'bg-slate-800/60 border border-white/5 text-slate-200'
              }`}>
                <div className="whitespace-pre-wrap">{m.content}</div>
              </div>
            </div>
          ))
        )}
        {sending && (
          <div className="text-slate-500 text-xs text-center py-2">{t('hc_67183189')}</div>
        )}
      </div>

      <div className="ai-mobile-foot">
        {messages.length > 0 && (
          <button
            type="button"
            onClick={onReset}
            className="text-slate-500 hover:text-slate-300 text-xs min-w-[44px] min-h-[44px]"
            title="清空对话"
          >↻</button>
        )}
        <textarea
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
          placeholder={t('problem.inputPlaceholder') || '问 AI 一个具体问题…'}
          rows={1}
        />
        <button
          type="button"
          onClick={() => handleSend()}
          disabled={sending || !input.trim()}
        >{t('hc_38124998')}</button>
      </div>
    </div>
  );
}
